import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-selection-sort",
    templateUrl: "./selection-sort.component.html",
    styleUrls: ["./selection-sort.component.scss"],
    standalone: false
})
export class SelectionSortComponent implements OnInit {
  constructor() {
    //Empty constructor intentional
  }

  ngOnInit(): void {
    //do nothing, leave this comment to avoid sonar error
  }

  sortSelectedOptions(allOptions: any, selected: any) {
    if (!allOptions) {
      return [];
    }
    const sel = [];
    const copy = allOptions.sort((a: any, b: any) => {
      if (
        a.value ||
        (a.value && a.value.length === 0) ||
        a.display === "<blank>"
      ) {
        return a.value.toLowerCase().localeCompare(b.value.toLowerCase());
      } else {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      }
    });
    this.handleSelectionLogic(copy, selected, sel);
    const ret = copy.filter((value) => !sel.includes(value));
    return [...sel, ...ret];
  }

  private handleSelectionLogic(copy: any, selected: any, sel: any[]) {
    copy.forEach((x) => {
      selected.forEach((val) => {
        if (x.value === val && !sel.includes(x.value)) {
          sel.push(x);
        } else if (x === val && !sel.includes(x)) {
          sel.push(x);
        }
      });
    });
  }
}
